import request from '@/utils/request'
const qs = require('qs')
// 分页账号列表
export function userPage(params) {
  return request({
    url: '/user/manage/page',
    method: 'post',
    data: params
  })
}
// 新增账号
export function userAdd(params) {
  return request({
    url: '/user/manage/save',
    method: 'post',
    need: true,
    data: params
  })
}
// 账号管理-编辑账号信息
export function userEdit(params, id) {
  return request({
    url: `/user/manage/${id}/edit`,
    method: 'post',
    need: true,
    data: params
  })
}
// 账号的站点列表
export function userStationList(params, id) {
  return request({
    url: `/user/${id}/station/list`,
    method: 'post',
    data: qs.stringify(params)
  })
}
// 账号分配站点
export function userStationAssign(params, id) {
  return request({
    url: `/user/${id}/station/assign`,
    method: 'post',
    data: qs.stringify(params)
  })
}
// 删除账号
export function userDelete(params, id) {
  return request({
    url: `/user/manage/${id}/delete`,
    method: 'post',
    data: qs.stringify(params)
  })
}
// 禁用账号状态
export function userDisable(params, id) {
  return request({
    url: `/user/manage/${id}/disable`,
    method: 'post',
    data: qs.stringify(params)
  })
}
// 恢复账号状态
export function userEnable(params, id) {
  return request({
    url: `/user/manage/${id}/enable`,
    method: 'post',
    data: qs.stringify(params)
  })
}
// 重置密码
export function userResetPwd(params, id) {
  return request({
    url: `/user/manage/${id}/resetPwd`,
    method: 'post',
    data: qs.stringify(params)
  })
}
// 角色列表
export function roleList(params) {
  return request({
    url: '/user/manage/role/list',
    method: 'post',
    data: qs.stringify(params)
  })
}
// 角色详情
export function userInfo(params, id) {
  return request({
    url: `/user/manage/${id}/get`,
    method: 'post',
    data: qs.stringify(params)
  })
}
// 账号管理:获取告警配置信息
export function userAlarmConfig(params) {
  return request({
    url: '/user/manage/alarmConfig',
    method: 'post',
    data: qs.stringify(params)
  })
}

// 账号管理:查看当前登录用户账号个人信息
export function userManageInfo(params) {
  return request({
    url: '/user/manage/get',
    method: 'post',
    data: qs.stringify(params)
  })
}
